module.exports = __webpack_public_path__ + "static/img/sl-3.4f00dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/sl-3.png
// module id = ZL8D
// module chunks = 0